import { Question } from '@app/models';

export class Widget {
    
    value: any = null;
    constructor(value: any = null){
        this.value = value;
    }
    
    get enableDemonstrations() : boolean {
        return this.value?.options?.hasVisio || this.value?.options?.hasPhysical;
    }
    
    get enableQuestionsAmbassador() : boolean {
        return this.value?.options?.hasAmbassadorQuestion || false;
    }
    
    get enableQuestionsCommunity() : boolean {
        return this.value?.options?.hasCommunityQuestion || false;
    }
    
    get questionsCommunity(): Array<Question> {
        return (this.value?.questionsCommunity || [])
            .sort((a: any, b: any) => (new Date(b.date).getTime() - new Date(a.date).getTime()));
    }
}

